import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { HFSpinner } from '@hf/designSystem/v1';
import { PATHS } from '@core/routes';
import { useAccount } from '@core/utils/auth';
import { FEATURE_FLAG_KEYS, useFeatureFlags } from '@core/utils/flags';

/** `oms` off, missing, or an internal session → Home. On → the OMS shell. */
export function OmsGate({ children }: { children: ReactNode }) {
  const { user } = useAccount();
  const { ready, isEnabled } = useFeatureFlags();

  if (!ready) {
    return <HFSpinner center sx={{ minHeight: '40vh' }} />;
  }

  if (user?.source === 'internal' || !isEnabled(FEATURE_FLAG_KEYS.oms)) {
    return <Navigate to={PATHS.home} replace />;
  }

  return children;
}
